import { useRef, useEffect } from "react";
import gsap from "gsap";
import YellowEye from "../../components/assets/eyes/YellowEye";
import LightBlueEye from "../../components/assets/eyes/LightBlueEye";
import PinkEye from "../../components/assets/eyes/PinkEye";
import BlueEye from "../../components/assets/eyes/BlueEye";
export default function ContactTransition() {
    const container = useRef(null);

    function randomValue() {
        return gsap.utils.random(-20, 20);
    }

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (container.current) {
                Array.from(container.current.children).forEach((element) => {
                    gsap.to(element, {
                        x: randomValue(),
                        y: randomValue()
                    })
                })
            }
        });
    }, []);
    return (
        <div className="min-h-dvh mobile:min-h-[75dvh] flex justify-center items-center flex-col p-[10rem] max-w-full overflow-hidden">
            <div className="relative w-full grow font-bold uppercase whitespace-nowrap" ref={container}>
                <div className="text-[6.25rem] tablet:text-[4.25rem] mobile:text-[3.25rem] absolute top-1/2 left-1/4 tablet:top-2/3 tablet:left-0 mobile:-left-16 -rotate-[4.5deg]">
                    Des questions ?
                </div>
                <div className="text-[7rem] tablet:text-[5rem] mobile:text-[4rem] absolute right-0 tablet:-right-1/4 top-0 rotate-[10deg] text-zoeil-yellow">
                    Un conseil ?
                </div>
                <div className="text-[6.625rem] tablet:text-[4.625rem] mobile:text-[3.625rem] absolute left-0 bottom-0 tablet:-bottom-32 rotate-[7deg] text-zoeil-light-blue">
                    Un devis ?
                </div>
                <div className="text-[5.125rem] tablet:text-[3.125rem] mobile:text-[2.125rem] absolute right-0 bottom-0 -rotate-[11deg] text-zoeil-blue mobile:-right-[10%]">
                    Blabla
                </div>
                <div className="text-[5.4375rem] tablet:text-[3.4375rem] mobile:text-[3.4375rem] absolute left-0 top-0 mobile:top-[10%] tablet:-left-[10%] -rotate-[11deg] text-zoeil-pink">
                    Un RDV ?
                </div>
                <div className="w-[6.6875rem] tablet:w-[4.6875rem] aspect-square absolute top-1/2 left-0 -rotate-[20deg]">
                    <YellowEye />
                </div>
                <div className="w-[6.6875rem] tablet:w-[4.6875rem] aspect-square absolute top-[40%] right-0">
                    <LightBlueEye />
                </div>
                <div className="w-[6.6875rem] tablet:w-[4.6875rem] aspect-square absolute left-1/2 mobile:left-0 bottom-0">
                    <PinkEye version={2}/>
                </div>
                <div className="w-[6.6875rem] tablet:w-[4.6875rem] aspect-square absolute left-1/3 top-0 tablet:top-1/4 rotate-[180deg]">
                    <BlueEye />
                </div>
            </div>
        </div>
    )
}